import { Injectable } from '@angular/core';
import {LocationModel} from '../models/location.model'
import { environment } from "../../environments/environment"
import { AppSettings } from '../config/AppSettings';

import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http : HttpClient,private appsetting : AppSettings) { }

  saveLocation( location:LocationModel){
   
     let httpParam : HttpParams=new HttpParams();
     
      return this.http.post(this.appsetting.get("server-url") + "/api/cpms/location/location",location,{observe:"response"})
   
  }
  getlocationlist() {
      let httpParam : HttpParams=new HttpParams();
      return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/listall" ,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    getAllLocation(request:any) {
      const params = request;
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/queryall" ,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }

    searchLocation(field:any,value:any) {
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/"+field+"/"+value ,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    getChargerlistbylocation(request:any) {
      const params = request;
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/charger/locationcharger" ,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    getStaticLoadLimit(request:any) {
      const params = request;
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.get( this.appsetting.get("server-url") +"/api/cpms/staticpowerlimit/list/"+ params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    EditCapacity(request:any) {
      const params = request;
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/staticpowerlimit/update" ,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    AddLoadbalancing(request:any) {
      const params = request;
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/policyrule" ,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }

    EditLoadbalancing(request:any) {
      const params = request;
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.put(this.appsetting.get("server-url") +"/api/cpms/location/policyrule" ,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    DeleteLoadbalancing(id:any) {
      let httpParam : HttpParams=new HttpParams();
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/policyrule/"+id ,{ observe : "body", params : httpParam,responseType : "json"})
    }
    
    loadBalancingList(request:any) {
     const params = request;
    
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/policyrules",params ,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    addEnergyRule(request:any) {
      const params = request;
     
   
       let httpParam : HttpParams=new HttpParams();
      
       
         return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/addenergysource",params ,{ observe : "body", params : httpParam,responseType : "json"})
     
     }
     GetEnergyList(request:any) {
     const params = request;
   
  
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/energysource",params ,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    MaxDemand(request:any) {
    
   
       let httpParam : HttpParams=new HttpParams();
      
       
         return this.http.get( this.appsetting.get("server-url") +"/api/cpms/location/stats?locationId="+request ,{ observe : "body", params : httpParam,responseType : "json"})
     
     }
     Getdiscom(type:any) {
      
     
   
       let httpParam : HttpParams=new HttpParams();
      
       
         return this.http.post( this.appsetting.get("server-url") +"/api/cpms/company/"+type ,{ observe : "body", params : httpParam,responseType : "json"})
     
     }
     getlocationbyId(request:any) {
      
      const params = request;
   
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/query" ,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    loadLocationData(locationId:any) {
      
      
   
      let httpParam : HttpParams=new HttpParams();
     
      
        return this.http.get( this.appsetting.get("server-url") +"/api/cpms/cpo/location/"+locationId,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    utilizationLocation(locationId:any,request:any) {
      
      const params = request;
     
      let httpParam : HttpParams=new HttpParams();
      
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/stats/location/"+locationId,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    loadLocation(locationId:any,request:any) {
      
      const params = request;
     
      let httpParam : HttpParams=new HttpParams();
      
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/reports/location/load/range/"+locationId,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    energyLocation(locationId:any,request:any) {
      
      const params = request;
     
      let httpParam : HttpParams=new HttpParams();
      
      
        return this.http.post( this.appsetting.get("server-url") +"/api/cpms/stats/location/energy/"+locationId,params,{ observe : "body", params : httpParam,responseType : "json"})
    
    }
    deleteLocation(uuid:string) {
        let httpParam : HttpParams=new HttpParams();
        
        
          return this.http.post( this.appsetting.get("server-url") +"/api/cpms/location/changestatus/"+uuid,{ observe : "body", params : httpParam,responseType : "json"})
      
      }


      verify(partyId:any,uuid:any) {
      
     
   
        let httpParam : HttpParams=new HttpParams();
       
        
          return this.http.post( this.appsetting.get("server-url") +"/api/cpms/cpo/datasync/"+partyId+'/'+uuid ,{ observe : "body", params : httpParam,responseType : "json"})
      
      }

      businessHours(request:any,uuid:any) {
      
     
   
        let httpParam : HttpParams=new HttpParams();
       
        
          return this.http.post(this.appsetting.get("server-url") +"/api/cpms/businesshours/"+uuid,request ,{ observe : "response"})
      
      }
      businessHoursList(uuid:any) {
      
    
        let httpParam : HttpParams=new HttpParams();
       
        
          return this.http.get(this.appsetting.get("server-url") +"/api/cpms/businesshours/"+uuid ,{ observe : "body", params : httpParam,responseType : "json"})
      
      }
      smartNotificationsList(uuid:any) {
      
    
        let httpParam : HttpParams=new HttpParams();
       
        
          return this.http.get( this.appsetting.get("server-url") +"/api/cpms/smartnotifications/"+uuid ,{ observe : "body", params : httpParam,responseType : "json"})
      
      }

      deleteSmartNotifications(id:any) {
      
    
        let httpParam : HttpParams=new HttpParams();
       
        
          return this.http.delete( this.appsetting.get("server-url") +"/api/cpms/smartnotifications/"+id ,{ observe : "response"})
      
      }

      saveSmartNotification(request:any,uuid:any) {
      
     
   
        let httpParam : HttpParams=new HttpParams();
       
        
          return this.http.post(this.appsetting.get("server-url") +"/api/cpms/smartnotifications/"+uuid,request ,{ observe : "response"})
      
      }

      agentList(uuid:any) {
      
    
        let httpParam : HttpParams=new HttpParams();
       
        
          return this.http.get( "https://tippi.linuxmantra.com/api/users" ,{ observe : "body", params : httpParam,responseType : "json"})
      
      }


      bulkLoadDownload(request:any) {
 
        const params = request;
          let httpParam : HttpParams=new HttpParams();
         
          
            return this.http.post(this.appsetting.get("server-url") +"/api/cpms/reports/download/location/load" ,params,{ observe : "body", params : httpParam,responseType : "blob"})
        
        }
}
